import React from 'react';
import { connect } from 'react-redux';
import { Roles } from '../../utils/enums/Roles';

export interface IRoleDependentReduxProps {
    role?: string | undefined;
    isReadOnly?: boolean | undefined;
    isAccountManager?: boolean | undefined;
    isConfigurationManager?: boolean | undefined;
    isClient?: boolean | undefined;
    isTempLogin?: boolean | undefined;
}

export interface IRoleDependentProps extends IRoleDependentReduxProps {
    allowed: string[];
    content: JSX.Element;
    isPublic?: boolean | undefined;
    isNotAuthorized?: boolean | undefined;
}

function mapStateToProps(state: any) {
    const { authentication } = state;
    return {
        role: authentication.role,
        isClient: authentication.isClient,
        isTempLogin: authentication.isTempLogin,
        isReadOnly: authentication.isReadOnly,
        isAccountManager: authentication.isAccountManager,
        isConfigurationManager: authentication.isConfigurationManager,
    };
}

class RoleDependent extends React.Component<IRoleDependentProps, Record<string, unknown>> {
    public override render() {
        const isAccountManagerAllowed =
            this.props.isAccountManager &&
            (this.props.isClient || this.props.role === Roles.Administrator) &&
            this.props.allowed.indexOf(Roles.AccountManager) !== -1;
        const isConfigurationMangerAllowed = this.props.isConfigurationManager && this.props.allowed.indexOf(Roles.ConfigurationManager) !== -1;

        if (this.props.isNotAuthorized) {
            return null;
        }
        if (!this.props.content) {
            return null;
        } else if (this.props.isPublic) {
            if (this.props.role === Roles.Administrator) {
                return this.props.content;
            }
            return null;
        } else if (isAccountManagerAllowed || isConfigurationMangerAllowed) {
            return this.props.content;
        } else if (this.isReadOnlyAllowed() && (this.isClientAndClientAllowed() || this.isCurrentRoleAllowed())) {
            return this.props.content;
        }
        return null;
    }

    private isClientAndClientAllowed() {
        return this.props.isClient && this.props.allowed.indexOf(Roles.Client) !== -1;
    }

    private isReadOnlyAllowed() {
        if (!this.props.isReadOnly) {
            return true;
        }
        return this.props.isReadOnly && this.props.allowed.indexOf(Roles.ReadOnly) !== -1;
    }

    private isCurrentRoleAllowed() {
        if (!this.props.role) {
            return false;
        }
        return this.props.allowed.indexOf(this.props.role) !== -1;
    }
}

// eslint-disable-next-line import/no-default-export
export default connect<IRoleDependentReduxProps, IRoleDependentProps, Record<string, unknown>>(mapStateToProps)(RoleDependent);
